<template>
  <canvas ref="canvas" class="scene"></canvas>
</template>

<script setup lang="ts">
import * as THREE from 'three'
import fragment from '../assets/shaders/hero.frag?raw'
import vertex from '../assets/shaders/hero.vert?raw'
import { onMounted, onBeforeUnmount, ref } from 'vue'

const canvas = ref<HTMLCanvasElement | null>(null)
let renderer: any
let scene: any
let camera: any
let uniforms: any
let animationId = 0
let resizeHandler: (() => void) | null = null

onMounted(() => {
  const el = canvas.value!
  renderer = new THREE.WebGLRenderer({ canvas: el, antialias: true, alpha: false })
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.75))
  scene = new THREE.Scene()
  uniforms = {
    u_time: { value: 0 },
    u_resolution: { value: new THREE.Vector2(1, 1) },
  }
  const resize = () => {
    const w = el.clientWidth || window.innerWidth
    const h = el.clientHeight || window.innerHeight
    renderer.setSize(w, h, false)
  camera = new THREE.OrthographicCamera(-1, 1, 1, -1, 0, 1)
  if (uniforms && uniforms.u_resolution) uniforms.u_resolution.value.set(w, h)
  }
  resize()
  resizeHandler = resize
  window.addEventListener('resize', resize)
  const geometry = new THREE.PlaneGeometry(2, 2)
  const material = new THREE.ShaderMaterial({
    uniforms,
    vertexShader: vertex,
    fragmentShader: fragment,
  })
  const mesh = new THREE.Mesh(geometry, material)
  scene.add(mesh)

  const tick = (t: number) => {
  uniforms.u_time.value = t * 0.0001
    renderer.render(scene, camera)
    animationId = requestAnimationFrame(tick)
  }
  animationId = requestAnimationFrame(tick)
})

onBeforeUnmount(() => {
  cancelAnimationFrame(animationId)
  renderer?.dispose()
  if (resizeHandler) window.removeEventListener('resize', resizeHandler)
})
</script>

<style scoped>
.scene { position: absolute; inset: 0; width: 100%; height: 100%; display: block; }
</style>
